/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  window.vickes = {
    alert_message: `
             █████╗ ██████╗ ███████╗ █████╗                  
            ██╔══██╗██╔══██╗██╔════╝██╔══██╗                 
            ███████║██████╔╝█████╗  ███████║                 
            ██╔══██║██╔══██╗██╔══╝  ██╔══██║                 
            ██║  ██║██║  ██║███████╗██║  ██║                 
            ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝                 
                                                             
██████╗ ███████╗███████╗████████╗██████╗ ██╗████████╗ █████╗ 
██╔══██╗██╔════╝██╔════╝╚══██╔══╝██╔══██╗██║╚══██╔══╝██╔══██╗
██████╔╝█████╗  ███████╗   ██║   ██████╔╝██║   ██║   ███████║
██╔══██╗██╔══╝  ╚════██║   ██║   ██╔══██╗██║   ██║   ██╔══██║
██║  ██║███████╗███████║   ██║   ██║  ██║██║   ██║   ██║  ██║
╚═╝  ╚═╝╚══════╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝   ╚═╝   ╚═╝  ╚═╝
              Protocolo de Segurança Ativado!
`
  }
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // window.customElements.define('flickity-controls', class extends HTMLElement {
  //   async connectedCallback() {
  //     this.flickityCarousel.addEventListener('flickity:ready', this._onSlideChanged.bind(this, false));
  //     this.flickityCarousel.addEventListener('flickity:slide-changed', this._onSlideChanged.bind(this, true));

  //     this.delegate.on('click', '[data-action="prev"]', () => this.flickityCarousel.previous());
  //     this.delegate.on('click', '[data-action="next"]', () => this.flickityCarousel.next());
  //     this.delegate.on('click', '[data-action="select"]', (event, target) =>
  //       this.flickityCarousel.select('#' + target.getAttribute('aria-controls'))
  //     );
  //   }

  //   get flickityCarousel() {
  //     return this._flickityCarousel = this._flickityCarousel ||
  //       document.getElementById(this.getAttribute('controls'));
  //   }

  //   async _onSlideChanged(animate = true) {
  //     let flickity = await this.flickityCarousel.flickityInstance;

  //     Array.from(this.querySelectorAll(`[aria-controls="${flickity.selectedElement.id}"]`))
  //       .forEach(element => {
  //         element.setAttribute('aria-current', 'true');
  //         getSiblings(element).forEach(sibling => sibling.removeAttribute('aria-current'));

  //         requestAnimationFrame(() => {
  //           if (element.offsetParent && element.offsetParent !== this) {
  //             const parentHeightHalf = element.offsetParent.clientHeight / 2;
  //             const parentWidthHalf = element.offsetParent.clientWidth / 2;

  //             element.offsetParent.scrollTo({
  //               behavior: animate ? 'smooth' : 'auto',
  //               top: element.offsetTop - parentHeightHalf + element.clientHeight / 2,
  //               left: element.offsetLeft - parentWidthHalf + element.clientWidth / 2
  //             });
  //           }
  //         });
  //       });
  //   }
  // });
})();
